import React from 'react';

export function SupportHelpIcon({ size = 16, strokeWidth = 1.8, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth={strokeWidth} />
      <path
        d="M9.6 9a2.45 2.45 0 0 1 4.52 1.29c0 1.57-1.89 2.2-1.89 3.52"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="17.2" r="1.05" fill="currentColor" />
    </svg>
  );
}

export default function SupportHelpButton({
  label = 'Help',
  ariaLabel,
  iconOnly = false,
  title,
  className = '',
  style = {},
  ...buttonProps
}) {
  return (
    <button
      type="button"
      className={className}
      aria-label={ariaLabel || label}
      title={title || label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: iconOnly ? 0 : 8,
        minHeight: 36,
        padding: iconOnly ? '0 10px' : '0 12px',
        borderRadius: 999,
        border: '1px solid rgba(255,255,255,0.14)',
        background: 'rgba(255,255,255,0.06)',
        color: 'white',
        cursor: 'pointer',
        fontSize: '0.82rem',
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        ...style,
      }}
      {...buttonProps}
    >
      <SupportHelpIcon size={16} />
      {!iconOnly ? <span>{label}</span> : null}
    </button>
  );
}
